/**
 * Per-bullet length clamp for extraction-concern text: pre-style-rules Merlin
 * concerns run to whole paragraphs (prod mean 228 chars, max 574 — kanban
 * 8f1eb421), so anything past this shows a word-boundary excerpt with its own
 * "more" toggle. Post-rules bullets (~90 chars) never hit it.
 *
 * Lives outside the .tsx component so the react-refresh/only-export-components
 * lint rule holds (see kb be9ee08a).
 */
export const CLAMP_CONCERN_CHARS = 160;

/** Word-boundary excerpt of a clamped concern (without the ellipsis). */
export function clampExcerpt(text: string): string {
  const slice = text.slice(0, CLAMP_CONCERN_CHARS - 20);
  const lastSpace = slice.lastIndexOf(' ');
  return lastSpace > 60 ? slice.slice(0, lastSpace) : slice;
}
